import { getCurrentUser } from 'lib/utils/store/currentUser'

const useCurrentUser = () => {
    return getCurrentUser()
}

export default useCurrentUser
